<template>
  <b-card>

    <!-- media -->
    <!-- <b-media no-body>
      <b-media-aside>
        <b-link>
          <b-img
            ref="previewEl"
            rounded
            :src="userData.foto"
            height="80"
            :key="reloadImg"
          />
        </b-link>
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          Upload
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="profileFile"
          accept=".jpg, .png, .gif"
          :hidden="true"
          plain
          @change="onFileSelected"
        />

        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75"
        >
          Reset
        </b-button>
        <b-card-text>Allowed JPG, GIF or PNG. Max size of 800kB</b-card-text>
      </b-media-body>
    </b-media> -->
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Nama"
            label-for="account-name"
          >
            <b-form-input
              v-model="biodata.nama"
              name="Nama"
              placeholder="Nama"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="biodata.email"
              name="email"
              placeholder="Email"
            />

          </b-form-group>
        </b-col>

        <!-- alert -->
        <!-- <b-col
          cols="12"
          class="mt-75"
          v-if="$route.params.warning_show === true"
        >
          <b-alert
            show
            variant="warning"
            class="mb-50"
          >
            <h4 class="alert-heading">
              Lengkapi NPM Anda pada tab Biodata
            </h4>
            <div class="alert-body">
              <b-link class="alert-link">
                Terimakasih
              </b-link>
            </div>
          </b-alert>
        </b-col> -->
        <!--/ alert -->

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ubahGeneralUUID,
  getUserUUID,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      profileFile: null,
      reloadImg: 0,
      biodata: {},
    }
  },
  mounted() {
    getUserUUID(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.biodata = response.data.data
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.userData.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.profileFile);
    },
    onFileSelected(event) {
      this.profileFile = event.target.files[0];
      this.renderImage();
    },
    async simpanData() {
      ubahGeneralUUID(this.biodata)
      .then(response => {
        if (response.data.success == true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data Berhasil Disimpan',
            },
          })
          this.getUserUUID()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
  },
}
</script>
